import { createSlice } from "@reduxjs/toolkit";
import {
  getToken,
  getUser,
  isTokenExpired,
} from "../Components/Avatar/Utility";

const token = getToken(); // Call getToken() once
const user = getUser(); //call getuser once


const initialState = {
  token: token || null,
  isAuthenticated: !!token && !isTokenExpired(token),
  user: user || null,
  multiStepProcessId: user?.multiStepProcessId || null
};
console.log(initialState);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      // console.log(action, 'action')
      const { token, user } = action.payload;
      state.token = token;
      state.isAuthenticated = true;
      state.user = user;
      state.multiStepProcessId = user?.multiStepProcessId || null; // Initialize correctly
      // localStorage.setItem('authToken', action.payload); // Store token in local storage
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      state.user = null;
      state.multiStepProcessId = null;  // Ensure multiStepProcessId is reset
      // localStorage.removeItem('authToken'); // Remove token from local storage
    },
    updatemultiStepProcessId: (state, action) => {
      const { multiStepProcessId } = action.payload;
      if (state.user) {
        state.user = {
          ...state.user,  // Copy the existing user object
          multiStepProcessId,  // Update only the multiStepProcessId field
        };
        state.multiStepProcessId = multiStepProcessId;  // Update in Redux state
      }
      
    }
  },
});

export const { login, logout, updatemultiStepProcessId } = authSlice.actions;
export default authSlice.reducer;
